/*
 * 版权声明
 * 上海万位数字技术有限公司（以下简称“本公司”）对其自行研究开发、编写编制的软件程序、代码等（以下简称“研发资料”）均受《中华人民共和国反不正当竞争法》、《中华人民共和国著作权法》、《中华人民共和国专利法》及适用之国际公约中有关著作权、专利权及/或其他财产所有权法律的保护，为本公司专属或持有。
 * 使用者将本公司专属或持有的研发资料用于商业、营利、广告性目的时，需事先征得本公司书面特别授权，并注明出处“上海万位数字技术有限公司”，并按照有关国际公约及中华人民共和国法律的有关规定，向本公司支付使用费。
 * 未经本公司事先明确的书面特别授权，任何单位或个人不得以任何形式、任何途径，通过任何渠道变更、篡改、发行、发布、散布、复制、重制、展示或利用研发资料全部或部分内容，否则以侵权论，依法追究法律责任。
 *
 * Copyright Notice
 * All the software programs and codes among others (hereinafter referred to as the R&D data) solely developed and written by Shanghai Wanway Digital Technology Co., Ltd. (hereinafter referred to as the Company) are protected by the Law of the People's Republic of China against Unfair Competition, Copyright Law of the People's Republic of China, Patent Law of the People's Republic of China and provisions on laws of copyrights, patent rights and/or other property ownership in international conventions that apply and exclusive to or owned by the Company.
 * While using the R&D data exclusive to or possessed by the Company for any commercial, marketing, or advertising purpose, users need ask for special authorization from the Company in writing beforehand, note the source "Shanghai Wanway Digital Technology Co., Ltd." and pay the Company royalties subject to relevant provisions in related international conventions and laws of the People's Republic of China.
 * With no prior and express written special authorization from the Company, any unit or individual shall not alter, tamper, issue, release, distribute, duplicate, remake, produce or use part or all of the R&D data in any form and any way, otherwise it shall be deemed as infringement and subject to legal penalties by law.
 */

/**
 * Created by lvshenchao on 2017/10/11.上传文件
 */
import React from 'react';
import {Form, Input, Select, Button, message, Icon, Spin, Progress} from 'antd';

let accessid = '';
let accesskey = '';
let host = '';
let policyBase64 = '';
let signature = '';
let callbackbody = '';
let upLoadObj = {}
let filename = '';
let key = '';
let suffix = '';
let expire = 0;
let g_object_name = '';
let g_object_name_type = 'random_name';
let now = Date.parse(new Date()) / 1000;
let timestamp = '';
let params;
let upLoadUrl=""
function send_request() {
    var xmlhttp = null;
    if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
    } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }

    if (xmlhttp != null) {
        let serverUrl = '/mic/policy?dir=xlsx&v=' + Date.parse(new Date()) / 1000;
        xmlhttp.open("GET", serverUrl, false);
        xmlhttp.send(null);
        return xmlhttp.responseText
    } else {
        alert("Your browser does not support XMLHTTP.");
    }
};

function check_object_radio() {
    g_object_name_type = 'random_name'
}

function get_signature() {
    //可以判断当前expire是否超过了当前时间,如果超过了当前时间,就重新取一下.3s 做为缓冲
    now = timestamp = Date.parse(new Date()) / 1000;
    if (expire < now + 3) {
        let body = send_request()
        var obj = eval("(" + body + ")");
        upLoadObj = eval("(" + body + ")")
        host = window.location.protocol + obj['host'].replace("http:", "").replace("https:", "")
        //测试环境特殊处理
        if (host && /rest/.test(host) &&
            (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("127.0.0.1") > 0)) {
            host = localStorage.getItem('url')
        }
        policyBase64 = obj['policy']
        accessid = obj['accessid']
        signature = obj['signature']
        expire = parseInt(obj['expire'])
        callbackbody = obj['callback']
        key = obj['dir']
        return true;
    }
    return false;
};

function random_string(len) {
    len = len || 32;
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

//获取后缀
function get_suffix(filename) {
    let pos = filename.lastIndexOf('.')
    suffix = ''
    if (pos != -1) {
        suffix = filename.substring(pos)
    }
    return suffix;
}

function calculate_object_name(filename) {
    if (g_object_name_type == 'local_name') {
        g_object_name += "${filename}"
    } else if (g_object_name_type == 'random_name') {
        suffix = get_suffix(filename)
        g_object_name = key + random_string(10) + suffix
    }
    return ''
}

function get_uploaded_object_name(filename) {
    if (g_object_name_type == 'local_name') {
        let tmp_name = g_object_name
        tmp_name = tmp_name.replace("${filename}", filename);
        return tmp_name
    } else if (g_object_name_type == 'random_name') {
        return g_object_name
    }
}

function set_upload_param(up, filename, ret) {
    if (ret == false) {
        ret = get_signature()
    }
    g_object_name = key;
    if (filename != '') {
        suffix = get_suffix(filename)
        calculate_object_name(filename)
    }
    let obj = {
        // "expire" : parseInt(upLoadObj['expire']),
        'key': g_object_name,

    }
    delete upLoadObj.dir
    delete upLoadObj.host
    delete upLoadObj.expire
    let new_multipart_params = Object.assign(upLoadObj, obj)
    up.setOption({
        'url': host,
        'multipart_params': new_multipart_params
    });

    up.start();
}



export default class AddUploadFile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filename: [],
            percent: 0
        }
    }

    componentDidMount() {
        let that = this;
        //自定义文件格式
        const {extensions} = this.props;
        var uploader = new plupload.Uploader({ //实例化一个plupload上传对象
            browse_button: that.props.selectFile,
            flash_swf_url: 'js/Moxie.swf',
            silverlight_xap_url: 'js/Moxie.xap',
            url: location.protocol + upLoadUrl,
            multi_selection: false,
            filters: {
                mime_types: [ //只允许上传csv ,txt文件
                    {title: "Excel files",extensions: extensions ? String(extensions) : "xls,xlsx,csv"},
                ],
                max_file_size: '10mb', //最大只能上传10mb的文件
                prevent_duplicates: false //不允许选取重复文件
            },
            init: {
                Refresh: function () {
                    set_upload_param(uploader, '', false);
                },
                FilesAdded: function (uploader, files) {
                    let fileNames = that.state.filename;
                    files.forEach(function (item) {
                        fileNames.push(item.name);
                    });
                    that.setState({
                        filename: fileNames,
                        percent: 0
                    })
                },
                BeforeUpload: function (uploader, file) {
                    check_object_radio();
                    set_upload_param(uploader, file.name, true);
                },
                UploadProgress: function (uploader, file) {
                    that.setState({
                        percent: file.percent
                    })
                },
                FileUploaded: function (uploader, file, info) {
                    if (info.status == 200 || info.status == 204) {
                        let filename = get_uploaded_object_name(file.name);
                        that.props.callBackFunc(filename,file.name);
                    } else {
                        message.error(info.response);
                    }
                },
                Error: function (uploader, err) {
                    if (err.code == -600) {
                        message.error(Strings.filemax ||'选择的文件太大了', 1);
                    } else if (err.code == -601) {
                        message.error('请选择excel格式的文件');
                    } else {
                        message.error(err.response, 3);
                    }
                }
            }
        });
        uploader.init(); //初始化
    }

    render() {
        return (
            <div className="upload_btn">
                <a id={this.props.selectFile} className="upload_a">
                    <i className="icon shangchuan"/>
                    {Strings.upload || "上传"}
                </a>
            </div>
        )
    }
}
